export const replaceBrowserRoute = (route, { notify = false } = {}) => {
  if (typeof window === "undefined") return;

  if (window.location.pathname !== route) {
    window.history.replaceState(window.history.state, document.title, route);
  }

  if (notify) {
    window.dispatchEvent(new Event("popstate"));
  }
};

export const pushBrowserRoute = (route, { notify = false } = {}) => {
  if (typeof window === "undefined") return;

  if (window.location.pathname !== route) {
    window.history.pushState(window.history.state, document.title, route);
  }

  if (notify) {
    window.dispatchEvent(new Event("popstate"));
  }
};
